import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import ErrorBoundary from 'components/ErrorBoundary';

const LoadableComponent = React.lazy(() => import('./ElectionBanner'));

export default class WithElectionBannerLoadable extends React.Component {
  constructor() {
    super();
    this.state = {};
  }
  componentDidMount() {
    // this.setState({});
    // this.setState({ load: true });
  }
  render() {
    const { wdtData, wrapperClassName } = { ...this.props };
    if (!wdtData) {
      return null;
    }
    return (
      <ErrorBoundary>
        <Suspense fallback={<div />}>
          <LoadableComponent
            wdtData={wdtData}
            wrapperClassName={wrapperClassName}
          />
        </Suspense>
      </ErrorBoundary>
    );
  }
}

WithElectionBannerLoadable.propTypes = {
  // imageUrl: PropTypes.string,
  wdtData: PropTypes.shape({}),
};

WithElectionBannerLoadable.defaultProps = {
  wdtData: undefined,
};
